import { Item, List, Root } from '@radix-ui/react-navigation-menu';

import type { ComponentProps } from 'react';

import { cn } from '@/lib/utils';

function NavigationMenu({ className, children, ...props }: ComponentProps<typeof Root>) {
  return (
    <Root
      data-slot="navigation-menu"
      className={cn('relative z-10 flex max-w-max flex-1', className)}
      {...props}
    >
      {children}
    </Root>
  );
}

function NavigationMenuList({ className, ...props }: ComponentProps<typeof List>) {
  return (
    <List
      data-slot="navigation-menu-list"
      className={cn('group flex flex-1 list-none items-center justify-center gap-1', className)}
      {...props}
    />
  );
}

function NavigationMenuItem({ className, ...props }: ComponentProps<typeof Item>) {
  return (
    <Item
      data-slot="navigation-menu-item"
      className={cn('relative w-full', className)}
      {...props}
    />
  );
}

export { NavigationMenu, NavigationMenuList, NavigationMenuItem };
